import axiosInstance from "./axiosInstanvce";

const _doGet = async (url) => {
  try {
    const response = await axiosInstance.get(url);
    return response.data;
  } catch (error) {
    console.error("Error retrieving data:", error);
  }
};

const _doPost = async (url, data) => {
  try {
    const response = await axiosInstance.post(url, data);
    return response.data;
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message;
    throw new Error(errorMessage);
  }
};

const useApi = {
  getSpeedTestResultsByGmid: async (gmid) => {
    return await _doGet(`/SpeedTestResult/byGmid/${gmid}`);
  },
  getAllSpeedTestResults: async () => {
    return await _doGet(`/SpeedTestResult/`);
  },
  createNewSpeedTestResult: async (data) => {
    return await _doPost(`/SpeedTestResult/`, data);
  },
};

export default useApi;
